export interface IndividualEventResponse {
  data: EventData[];
}

export interface UserSoloEventResponse {
  data: UserEventProgress[];
}

export interface UserGlobalEventResponse {
  data: (UserEventProgress & {
    participantsCount: number;
  })[];
}

export type ClaimStatusType = 'not.ready' | 'claimed' | 'claim';

export const EventTypeEnum = {
  GLOBAL: 1,
  SOLO: 2,
} as const;

export type EventType = (typeof EventTypeEnum)[keyof typeof EventTypeEnum];

export interface GlobalEventResponse {
  data: {
    events: GlobalEventData[];
    showFirst: number;
  };
}

export interface ScheduledEvent {
  endDate: string;
  portalEventId: number;
  startDate: string;
}
export interface ScheduledEventResponse {
  data: ScheduledEvent[];
}

export interface EventData {
  portalEventId: number;
  name: string;
  description: string;
  image: string;
  typeId: EventType;
  statId: number;
  milestones: Milestone[];
  startDate: string;
  endDate: string;
  updatedAt: string;
  createdAt: string;
  milestoneDescriptionTemplate: string;
  pointRules: PointRule[];
  statusId: number;
  parentEventId?: number;
  eventId: string;
  isNew: boolean;
  assetsBanner: AssetsBanner[];
  individualId: string;
  multiple: boolean;
  leaderboardId: string;
  type: string;
  totalPoints: number;
  globalLevel: number;
}

export interface GlobalEventData extends Omit<EventData, 'milestones'> {
  participantsCount: number;
  totalPoints: number;
  point: number;
  globalLevel: number;
  milestones: (Milestone & UserMilestoneProgress)[];
}

export interface UserMilestoneProgress {
  id: string;
  claimed: boolean;
  type?: ClaimStatusType;
  isChange?: boolean;
  level?: string;
}
export interface UserEventProgress {
  portalEventId: number;
  milestones: UserMilestoneProgress[];
  point: number;
}

export interface UserGlobalEventProgress extends UserEventProgress {
  userPoint: number | undefined;
  participantsCount: number | undefined;
}

export type UniUserEventProgress = UserEventProgress | UserGlobalEventProgress;

export interface Milestone {
  isNew?: boolean;
  isWritten?: boolean;
  requirement: number;
  image: string;
  name: string;
  description: string;
  rewards: Reward[];
  level: number;
  id: string;
  isCompleted?: boolean;
}

export interface Reward {
  itemId: string;
  quantity: number;
  displayName: string;
  imageUrl: string;
}

export interface PointRule {
  currencyId: number;
  value: number;
  rate: number;
  name?: string;
  id: string;
  description?: string;
  portalEventsStatId?: number;
  portalEventsSubStatId?: number;
}

export interface AssetsBanner {
  id: string;
  key: string;
  name: string;
  url: string;
}

export interface PlayerPoints {
  userId: string;
  playerImg?: string;
  playerPoints: number;
  isHidden?: boolean;
  playerName?: string;
  factionName?: string;
  playerTemporaryName?: string;
}

export interface PlayerRank extends PlayerPoints {
  playerRank?: number;
}

export interface UserRankResponse {
  data?: {
    currentPlayer?: PlayerRank;
    abovePlayer?: PlayerRank;
  };
}

export interface LeaderboardReward {
  rewardType: string;
  rewardCurrency?: string;
  rewardWeight: number;
  rewardQuantity: number;
  rewardInGameItem?: Partial<{
    offerItemId: string;
    offerDisplayName: string;
    offerImageUrl: string;
  }>;
}

export interface LeaderboardRankResponseObject {
  rows: PlayerRank[];
  claimPeriod: number;
  leaderboardId: string;
  popupDescriptionText: string;
  popupTitleText: string;
  brackets: Partial<{
    rewardId: string;
    rewardRankStartValue: number;
    rewardRankEndValue: number;
    rewardName: string;
    isClaimed: boolean;
    rewards: Partial<LeaderboardReward>[];
  }>[];
}

export interface LeaderboardRankResponse {
  data: Partial<LeaderboardRankResponseObject> | string;
}

interface LeaderboardRewardClaimStatus {
  eventType: number;
  userId: string;
  portalEventId: number;
  status: string;
  endDate: string;
  leaderboardId: string;
}

export interface LeaderboardRewardClaimStatusResponse {
  data: LeaderboardRewardClaimStatus[];
}

export interface UserRbeLeaderboardResponse
  extends LeaderboardRankResponseObject {
  currentPlayer?: PlayerRank;
  abovePlayer?: PlayerRank;
}
